/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";

export const Triggers: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">

                {/* Query List Here */}
                <QueryListProvider>
                    <QueryList 
                        listTitle={"Cash Flow Triggers"}
                        recordTitle={"Trigger"}
                        tableName={"sa_vendor_trigger"} 
                        editTableName={"sa_vendor_trigger"}
                        editHasCompoundKey={false}
                        join={[
                            {
                                "relationship": "vendor",
                                "joinType": "LEFT"
                            }
                        ]} 
                        select={[                               
                            {
                                fullColumnName : "vendor.co_name",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName : "name",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "days_offset",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "perc",
                                aggregate: ""
                            }
                        ]}
                        where={[]} 
                        orderBy={[    
                            {
                            fullColumnName: "vendor.co_name",
                            direction: "ASC",
                            cast: CastType.STRING
                            }
                        ]} 
                        groupBy={[]}                    
                    />
                </QueryListProvider> 
            </Container>
        </React.Fragment>
    );
}